import React from "react";
import { siteConfig } from "../mock";

const About = () => {
  return (
    <section
      className="relative w-full py-24 md:py-28"
      style={{
        background:
          "linear-gradient(180deg, #869e70 0%, #4a5a3a 35%, #1a1a1a 100%)",
      }}
    >
      <div className="max-w-[1100px] mx-auto px-6 text-center">
        <h2
          className="text-white mb-8"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(40px, 5vw, 64px)",
            fontWeight: 400,
            letterSpacing: "-0.5px",
          }}
        >
          {siteConfig.aboutTitle}
        </h2>
        <p
          className="text-white/95 mx-auto"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(17px, 1.35vw, 22px)",
            lineHeight: 1.55,
            fontWeight: 700,
            maxWidth: "1000px",
          }}
        >
          {siteConfig.aboutText}
        </p>
      </div>
    </section>
  );
};

export default About;
